import { render, staticRenderFns } from "./InboxReportItem.vue?vue&type=template&id=b6570c84"
import script from "./InboxReportItem.vue?vue&type=script&lang=js"
export * from "./InboxReportItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports